
const pushEvent = (eventCategory, eventAction, eventLabel, eventValue) => {
	if (self.ga){
		self.ga(
			"send",
			"event",
			eventCategory,
			eventAction,
			eventLabel,
			eventValue);
	}
};


export {
	pushEvent,
}
